import { render } from "./CalendariDataTable.vue?vue&type=template&id=2e7cbab7"
import script from "./CalendariDataTable.vue?vue&type=script&lang=js"
export * from "./CalendariDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__